import styled from "@emotion/styled";
import { Chip } from "@mui/material";

export const ChipStyled = styled(Chip)`
  width: max-content;
`;
